(() => {
  const mediaQueryList = window.matchMedia ? window.matchMedia('print') : undefined;
  const observedElems = new Set();

  const lazyLoad = (
    window.park.exports &&
    window.park.exports.config &&
    window.park.exports.config.lazyload
  );

  let rootMargin = lazyLoad ? window.park.exports.config.lazyload : '100px 50px 200px 50px';
  rootMargin = rootMargin.toString().replace(/,/gi, ' ');

  function replace(oldElement) {
    if (window.park.device.isOffline()) {
      window.setTimeout(() => {
        replace(oldElement);
      }, 1000);
    }

    const oldAttributes = oldElement.hasAttributes() ?
      Array.prototype.slice.call(oldElement.attributes) : [];
    const noscript = oldElement.querySelector('noscript');
    const dom = document.createElement('div');

    if (!noscript) {
      return;
    }

    dom.innerHTML = noscript.textContent ?
      noscript.textContent.replace(/<!--.+?-->/g, '').trim() : noscript.innerHTML.replace(/<!--.+?-->/g, '').trim();

    const newElement = dom.firstElementChild;

    oldAttributes.forEach((attribute) => {
      newElement.setAttribute(attribute.name, attribute.value);
    });

    if (oldElement.parentNode) {
      oldElement.parentNode.replaceChild(newElement, oldElement);
    }
  }

  function callback(entries, observer) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio > 0.01) {
        observer.unobserve(entry.target);

        replace(entry.target);
      }
    });
  }

  const observer = window.IntersectionObserver ? new IntersectionObserver(callback, {
    root: null,
    rootMargin,
    threshold: 0.1,
  }) : undefined;

  function replaceAll() {
    console.log('replaceAll!');

    observedElems.forEach((elem) => {
      observedElems.delete(elem);
      observer.unobserve(elem);
      replace(elem);
    });
  }

  window.park = Object.assign({}, window.park, {
    lazyLoad(elem) {
      if (window.IntersectionObserver) {
        observer.observe(elem);
        observedElems.add(elem);
      } else {
        replace(elem);
      }
    },
  });

  if (window.IntersectionObserver) {
    window.addEventListener('beforeprint', replaceAll);

    if (!window.matchMedia) {
      return;
    }

    mediaQueryList.addListener((mql) => {
      if (mql.matches) {
        replaceAll();
      }
    });
  }
})();
